export default __webpack_public_path__ + "static/media/no-results-person.3aac6bbf.svg";